import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import { useAuth } from "../../sdk/hooks";
import * as scheduleApi from "../../sdk/utils/api/price-change-schedule";
import { IBulkCreateResult } from "../../sdk/utils/api/price-change-schedule";

interface IBulkCreateParams {
    startsAt: string;
    endsAt: string;
    platforms: number[];
    notes?: string;
    rows: { variantId: string; sellingPrice: number }[];
}

export const useBulkCreateSchedules = (
    invalidQueryKeys: string | string[]
): UseMutationResult<IBulkCreateResult, unknown, IBulkCreateParams> => {
    const { token } = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IBulkCreateResult, unknown, IBulkCreateParams>(
        async (params) => {
            if (!token) throw new Error("Not authenticated");
            return await scheduleApi.bulkCreateSchedules(token, params);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(invalidQueryKeys);
            },
        }
    );
};
